interface iconProps {
  name: string;
  width?: string | number;
  height?: string | number;
  fill?: string;
}

export const PhoneIcon = ({ width = "50", height = "50" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M41.6667 22.9147H45.8333C45.8333 12.2272 37.7646 4.16675 27.0625 4.16675V8.33342C35.525 8.33342 41.6667 14.4647 41.6667 22.9147Z"
      fill="url(#paint0_linear_202_3619)"
    />
    <path
      d="M27.0839 16.6666C31.4652 16.6666 33.3339 18.5353 33.3339 22.9166H37.5006C37.5006 16.1978 33.8027 12.4999 27.0839 12.4999V16.6666ZM34.2131 28.0062C33.8128 27.6423 33.2867 27.4483 32.746 27.465C32.2053 27.4817 31.6923 27.7079 31.3152 28.0958L26.3298 33.2228C25.1298 32.9937 22.7173 32.2416 20.2339 29.7645C17.7506 27.2791 16.9985 24.8603 16.7756 23.6687L21.8985 18.6812C22.2869 18.3044 22.5134 17.7912 22.5301 17.2504C22.5468 16.7095 22.3524 16.1833 21.9881 15.7833L14.2902 7.31868C13.9257 6.91734 13.4191 6.6739 12.878 6.64005C12.3369 6.60621 11.8039 6.78463 11.3923 7.13743L6.87142 11.0145C6.51124 11.376 6.29625 11.8571 6.26725 12.3666C6.236 12.8874 5.64017 25.2249 15.2068 34.7958C23.5527 43.1395 34.0068 43.7499 36.886 43.7499C37.3068 43.7499 37.5652 43.7374 37.6339 43.7333C38.1433 43.7047 38.6242 43.4888 38.9839 43.127L42.8589 38.6041C43.212 38.1927 43.3908 37.6599 43.3573 37.1188C43.3238 36.5777 43.0808 36.071 42.6798 35.7062L34.2131 28.0062Z"
      fill="url(#paint1_linear_202_3619)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_202_3619"
        x1="27.3793"
        y1="4.16675"
        x2="46.4679"
        y2="4.8368"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7722" />
        <stop offset="1" stopColor="#FFB800" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_202_3619"
        x1="6.87635"
        y1="6.63599"
        x2="44.616"
        y2="7.95901"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7722" />
        <stop offset="1" stopColor="#FFB800" />
      </linearGradient>
    </defs>
  </svg>
);

export const EmailIcon = ({ width = "50", height = "50" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M45.8346 8.33325H4.16797V41.6666H45.8346V8.33325ZM41.668 16.6666L25.0013 27.0833L8.33464 16.6666V12.4999L25.0013 22.9166L41.668 12.4999V16.6666Z"
      fill="url(#paint0_linear_202_3623)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_202_3623"
        x1="4.8712"
        y1="8.33326"
        x2="47.2141"
        y2="10.1889"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7722" />
        <stop offset="1" stopColor="#FFB800" />
      </linearGradient>
    </defs>
  </svg>
);

export const LocationIcon = ({ width = "50", height = "50" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25 3.125C20.4433 3.13038 16.0747 4.94292 12.8526 8.16504C9.63044 11.3872 7.81789 15.7557 7.81252 20.3125C7.80706 24.0363 9.02343 27.659 11.275 30.625C11.275 30.625 11.7438 31.2422 11.8203 31.3312L25 46.875L38.186 31.3234C38.2547 31.2406 38.725 30.625 38.725 30.625L38.7266 30.6203C40.9771 27.6556 42.1929 24.0346 42.1875 20.3125C42.1821 15.7557 40.3696 11.3872 37.1475 8.16504C33.9254 4.94292 29.5568 3.13038 25 3.125ZM25 26.5625C23.7639 26.5625 22.5555 26.1959 21.5277 25.5092C20.4999 24.8224 19.6988 23.8463 19.2258 22.7043C18.7527 21.5622 18.629 20.3056 18.8701 19.0932C19.1113 17.8808 19.7065 16.7672 20.5806 15.8931C21.4547 15.019 22.5683 14.4237 23.7807 14.1826C24.9931 13.9414 26.2497 14.0652 27.3918 14.5383C28.5338 15.0113 29.5099 15.8124 30.1967 16.8402C30.8835 17.868 31.25 19.0764 31.25 20.3125C31.2479 21.9695 30.5888 23.558 29.4172 24.7296C28.2455 25.9013 26.657 26.5604 25 26.5625Z"
      fill="url(#paint0_linear_202_3616)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_202_3616"
        x1="8.39267"
        y1="3.125"
        x2="43.3662"
        y2="4.0884"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7722" />
        <stop offset="1" stopColor="#FFB800" />
      </linearGradient>
    </defs>
  </svg>
);
export const CheckMark = ({ width = "40", height = "40" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40 0C17.9313 0 0 17.9304 0 40C0 62.0697 17.9304 80 40 80C62.0697 80 80 62.0697 80 40C80 17.9304 62.0697 0 40 0ZM33.3293 58.0437L20.9833 45.6978L25.6866 40.9945L33.3293 48.6372L57.6379 24.3067L62.3412 29.01L33.3293 58.0437Z"
      fill="url(#paint0_linear_63_7944)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_63_7944"
        x1="1.35021"
        y1="8.66226e-06"
        x2="82.7047"
        y2="2.85223"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7722" />
        <stop offset="1" stopColor="#FFB800" />
      </linearGradient>
    </defs>
  </svg>
);
const Icons: { [key: string]: (fill?: string) => JSX.Element } = {
  location: (fill = "#6F7685") => (
    <>
      <g clipPath="url(#clip0_35_1975)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.99977 1.75C9.19325 1.75 10.3378 2.22411 11.1818 3.06802C12.0257 3.91193 12.4998 5.05653 12.4998 6.25C12.4998 6.79667 12.4024 7.33 12.2244 7.79933C11.7078 9.52467 10.4438 12.086 8.43111 15.504C8.38696 15.5791 8.32397 15.6413 8.24837 15.6846C8.17278 15.7278 8.0872 15.7505 8.00011 15.7505C7.91301 15.7505 7.82744 15.7278 7.75184 15.6846C7.67624 15.6413 7.61325 15.5791 7.56911 15.504C5.55577 12.086 4.29177 9.524 3.78577 7.83067C3.53032 7.14977 3.4437 6.41711 3.53333 5.69542C3.62295 4.97373 3.88615 4.28451 4.30039 3.68678C4.71462 3.08906 5.26755 2.60063 5.91183 2.26332C6.55611 1.92601 7.27254 1.74988 7.99977 1.75ZM7.99977 2.75C7.07151 2.75 6.18128 3.11875 5.5249 3.77513C4.86852 4.4315 4.49977 5.32174 4.49977 6.25C4.49977 6.676 4.57577 7.09 4.73311 7.51133C5.18177 9.01067 6.26244 11.248 7.97044 14.208L7.99911 14.2567L8.28577 13.7593C9.77177 11.1513 10.7458 9.13133 11.2118 7.692L11.2778 7.48C11.4766 6.95035 11.5441 6.3804 11.4744 5.81897C11.4047 5.25754 11.2 4.72136 10.8777 4.25637C10.5555 3.79138 10.1253 3.41144 9.62409 3.14909C9.12286 2.88674 8.56551 2.7498 7.99977 2.75Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 4.25C8.53043 4.25 9.03914 4.46071 9.41421 4.83579C9.78929 5.21086 10 5.71957 10 6.25C10 6.78043 9.78929 7.28914 9.41421 7.66421C9.03914 8.03929 8.53043 8.25 8 8.25C7.46957 8.25 6.96086 8.03929 6.58579 7.66421C6.21071 7.28914 6 6.78043 6 6.25C6 5.71957 6.21071 5.21086 6.58579 4.83579C6.96086 4.46071 7.46957 4.25 8 4.25ZM8 5.25C7.73478 5.25 7.48043 5.35536 7.29289 5.54289C7.10536 5.73043 7 5.98478 7 6.25C7 6.51522 7.10536 6.76957 7.29289 6.95711C7.48043 7.14464 7.73478 7.25 8 7.25C8.26522 7.25 8.51957 7.14464 8.70711 6.95711C8.89464 6.76957 9 6.51522 9 6.25C9 5.98478 8.89464 5.73043 8.70711 5.54289C8.51957 5.35536 8.26522 5.25 8 5.25Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_35_1975">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.75)"
          />
        </clipPath>
      </defs>
    </>
  ),

  facebook: (fill = "#0A142F") => (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.03976 15.2138V7.93153H0.53418V5.42192H2.03976V3.91516C2.03976 1.86782 2.8899 0.650391 5.30526 0.650391H7.31612V3.16029H6.05919C5.11895 3.16029 5.05675 3.51101 5.05675 4.16555L5.05334 5.42164H7.33035L7.06391 7.93125H5.05334V15.2138H2.03976Z"
        fill={fill}
      />
    </>
  ),
  twitter: (fill = "#0A142F") => (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.48006 3.4336L6.50742 3.89554L6.05143 3.83897C4.39163 3.62215 2.94158 2.88682 1.71041 1.65186L1.1085 1.03909L0.953469 1.49159C0.625156 2.50031 0.834911 3.56558 1.5189 4.28205C1.88369 4.678 1.80161 4.73456 1.17234 4.49888C0.953469 4.42346 0.761953 4.3669 0.743713 4.39518C0.679875 4.46117 0.89875 5.31905 1.07203 5.65843C1.30914 6.12979 1.79249 6.59173 2.32144 6.86512L2.76831 7.08194L2.23936 7.09137C1.72865 7.09137 1.71041 7.1008 1.76513 7.29877C1.94753 7.91154 2.66799 8.56202 3.47053 8.84484L4.03596 9.04281L3.54349 9.34448C2.81391 9.77813 1.95665 10.0232 1.09939 10.0421C0.688995 10.0515 0.351562 10.0892 0.351562 10.1175C0.351562 10.2118 1.46418 10.7397 2.11168 10.9471C4.0542 11.5599 6.3615 11.2959 8.09426 10.2495C9.32543 9.50474 10.5566 8.02467 11.1312 6.59173C11.4412 5.82812 11.7513 4.43289 11.7513 3.76356C11.7513 3.3299 11.7787 3.27334 12.2894 2.75484C12.5903 2.45317 12.873 2.12322 12.9278 2.02894C13.0189 1.84983 13.0098 1.84983 12.5447 2.01009C11.7695 2.29291 11.6601 2.2552 12.0431 1.83097C12.3258 1.5293 12.6633 0.982522 12.6633 0.822259C12.6633 0.793978 12.5265 0.841113 12.3714 0.925959C12.2073 1.02023 11.8425 1.16164 11.5689 1.24648L11.0764 1.40675L10.6296 1.09565C10.3833 0.925959 10.0368 0.737414 9.85438 0.680851C9.38927 0.54887 8.67793 0.567724 8.25842 0.71856C7.11845 1.14279 6.39798 2.23634 6.48006 3.4336Z"
        fill={fill}
      />
    </>
  ),
  linkedin: (fill = "#0A142F") => (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.39899 14.2429H0.486328V5.50488H3.39899V14.2429Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.934 3.56311H1.91745C1.04825 3.56311 0.486328 2.91554 0.486328 2.10625C0.486328 1.27984 1.06536 0.650391 1.95106 0.650391C2.83675 0.650391 3.38218 1.27984 3.39899 2.10625C3.39899 2.91554 2.83675 3.56311 1.934 3.56311Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0787 14.2426H11.2166V9.67518C11.2166 8.52794 10.8024 7.74509 9.76625 7.74509C8.9755 7.74509 8.50451 8.27284 8.29764 8.78258C8.22196 8.96526 8.20339 9.21979 8.20339 9.47494V14.2429H5.34082C5.34082 14.2429 5.37855 6.50668 5.34082 5.70558H8.20339V6.91482C8.58327 6.33351 9.26365 5.50488 10.7833 5.50488C12.6668 5.50488 14.0788 6.72534 14.0788 9.34762L14.0787 14.2426Z"
        fill={fill}
      />
    </>
  ),
  search: () => (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.1342 2.73392C39.447 3.921 41.5694 5.42824 43.4426 7.19746L45.5025 5.01649C43.4255 3.05475 41.0712 1.38257 38.504 0.0649414L37.1342 2.73392ZM45.4929 9.3553C47.1679 11.3207 48.5693 13.5254 49.6387 15.9103L52.3761 14.6829C51.1888 12.035 49.6337 9.5889 47.7762 7.4094L45.4929 9.3553ZM50.6958 18.6576C51.4808 21.0824 51.9367 23.6566 52.01 26.3285L55.0089 26.2463C54.9277 23.2849 54.4221 20.4274 53.55 17.7336L50.6958 18.6576ZM51.9361 29.2592C51.728 31.9185 51.14 34.4697 50.2267 36.8595L53.029 37.9305C54.0435 35.276 54.6962 32.4431 54.927 29.4932L51.9361 29.2592ZM24.6579 47.7504C36.067 47.7504 45.3158 38.5015 45.3158 27.0925C45.3158 15.6834 36.067 6.43457 24.6579 6.43457C13.2489 6.43457 4 15.6834 4 27.0925C4 38.5015 13.2489 47.7504 24.6579 47.7504ZM24.6579 50.7504C30.651 50.7504 36.1236 48.522 40.2923 44.8485L43.4806 48.0369L40.5571 51.0213L52.1495 62.3771C54.3896 64.5715 57.9845 64.5344 60.1788 62.2943C62.3732 60.0542 62.3362 56.4594 60.0961 54.265L48.5037 42.9092L45.5801 45.8937L42.4136 42.7272C46.0873 38.5585 48.3158 33.0857 48.3158 27.0925C48.3158 14.0266 37.7238 3.43457 24.6579 3.43457C11.592 3.43457 1 14.0266 1 27.0925C1 40.1584 11.592 50.7504 24.6579 50.7504ZM38.6917 27.0933C38.6917 34.8439 32.4086 41.127 24.658 41.127C16.9074 41.127 10.6243 34.8439 10.6243 27.0933C10.6243 19.3427 16.9074 13.0596 24.658 13.0596C32.4086 13.0596 38.6917 19.3427 38.6917 27.0933ZM41.6917 27.0933C41.6917 36.5007 34.0654 44.127 24.658 44.127C15.2505 44.127 7.62427 36.5007 7.62427 27.0933C7.62427 17.6858 15.2505 10.0596 24.658 10.0596C34.0654 10.0596 41.6917 17.6858 41.6917 27.0933ZM23.935 24.7273C25.051 25.3614 26.17 26.2679 27.0235 27.5289C27.8771 26.2679 28.996 25.3614 30.1121 24.7273C28.996 24.0931 27.8771 23.1867 27.0235 21.9256C26.17 23.1867 25.051 24.0931 23.935 24.7273ZM25.5235 16.6836H28.5235C28.5235 19.7224 30.0779 21.2884 31.6938 22.1746C32.5289 22.6325 33.3793 22.9013 34.0307 23.0544C34.3533 23.1302 34.6189 23.1757 34.7982 23.2018C34.8877 23.2148 34.955 23.2229 34.9965 23.2275C35.0172 23.2297 35.0314 23.2311 35.0386 23.2318L35.0401 23.232C35.0399 23.232 35.0398 23.2319 35.0388 23.2435V26.211C35.0398 26.2226 35.0399 26.2226 35.0401 26.2226L35.0386 26.2228C35.0314 26.2234 35.0172 26.2248 34.9965 26.2271C34.955 26.2317 34.8877 26.2397 34.7982 26.2527C34.6189 26.2788 34.3533 26.3244 34.0307 26.4002C33.3793 26.5533 32.5289 26.8221 31.6938 27.28C30.0779 28.1661 28.5235 29.7322 28.5235 32.771H25.5235C25.5235 29.7322 23.9692 28.1661 22.3532 27.28C21.5182 26.8221 20.6677 26.5533 20.0163 26.4002C19.6937 26.3244 19.4282 26.2788 19.2488 26.2527C19.1594 26.2397 19.0921 26.2317 19.0506 26.2271C19.0299 26.2248 19.0157 26.2234 19.0084 26.2228L19.007 26.2226C19.0071 26.2226 19.0072 26.2226 19.0083 26.211V23.2435L19.0072 23.2329C19.0071 23.232 19.0071 23.232 19.007 23.232L19.0084 23.2318C19.0157 23.2311 19.0299 23.2297 19.0506 23.2275C19.0921 23.2229 19.1594 23.2148 19.2488 23.2018C19.4282 23.1757 19.6937 23.1302 20.0163 23.0544C20.6677 22.9013 21.5182 22.6325 22.3532 22.1746C23.9692 21.2884 25.5235 19.7224 25.5235 16.6836ZM54.2488 60.234L44.7995 50.9776L48.5474 47.1516L57.9967 56.4081C59.0532 57.443 59.0707 59.1385 58.0358 60.195C57.0008 61.2515 55.3054 61.269 54.2488 60.234Z"
        fill="url(#paint0_linear_35_2444)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_35_2444"
          x1="2.02617"
          y1="0.0649483"
          x2="63.8636"
          y2="2.12666"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7722" />
          <stop offset="1" stopColor="#FFB800" />
        </linearGradient>
      </defs>
    </>
  ),
  star(fill = "#FFB800") {
    return (
      <>
        <path
          d="M8.46118 0.658304C8.63078 0.136341 9.36922 0.136341 9.53882 0.658304L11.1179 5.51836C11.1938 5.75179 11.4113 5.90983 11.6568 5.90983H16.7669C17.3157 5.90983 17.5439 6.61213 17.0999 6.93472L12.9657 9.9384C12.7672 10.0827 12.6841 10.3384 12.7599 10.5718L14.339 15.4319C14.5086 15.9538 13.9112 16.3879 13.4672 16.0653L9.33301 13.0616C9.13444 12.9173 8.86556 12.9173 8.66699 13.0616L4.53279 16.0653C4.08878 16.3879 3.49137 15.9538 3.66096 15.4319L5.24009 10.5718C5.31594 10.3384 5.23285 10.0827 5.03428 9.9384L0.900073 6.93472C0.456064 6.61213 0.684255 5.90983 1.23308 5.90983H6.34324C6.58868 5.90983 6.80621 5.75179 6.88206 5.51836L8.46118 0.658304Z"
          fill={fill}
        />
      </>
    );
  },
  discountTag() {
    return (
      <>
        <path
          d="M6.75299 2.05059C7.52667 -0.0327189 10.4733 -0.0327191 11.247 2.05059C11.6479 3.13001 12.7596 3.77188 13.8949 3.57933C16.0859 3.2077 17.5592 5.75958 16.1419 7.47127C15.4075 8.35813 15.4075 9.64187 16.1419 10.5287C17.5592 12.2404 16.0859 14.7923 13.8949 14.4207C12.7596 14.2281 11.6479 14.87 11.247 15.9494C10.4733 18.0327 7.52667 18.0327 6.75299 15.9494C6.35212 14.87 5.24038 14.2281 4.10514 14.4207C1.9141 14.7923 0.44077 12.2404 1.85813 10.5287C2.5925 9.64187 2.5925 8.35813 1.85813 7.47127C0.44077 5.75958 1.9141 3.2077 4.10514 3.57933C5.24038 3.77188 6.35212 3.13001 6.75299 2.05059Z"
          fill="url(#paint0_linear_262_8413)"
        />
        <g clipPath="url(#clip0_262_8413)">
          <path
            d="M7.33333 8.58342C7.62176 8.58342 7.90372 8.49789 8.14354 8.33764C8.38336 8.1774 8.57028 7.94964 8.68066 7.68316C8.79104 7.41669 8.81992 7.12346 8.76365 6.84058C8.70738 6.55769 8.56848 6.29784 8.36453 6.09388C8.16058 5.88993 7.90073 5.75104 7.61784 5.69477C7.33495 5.6385 7.04173 5.66738 6.77525 5.77776C6.50878 5.88814 6.28102 6.07505 6.12077 6.31488C5.96053 6.5547 5.875 6.83665 5.875 7.12508C5.875 7.51186 6.02865 7.88279 6.30214 8.15628C6.57563 8.42977 6.94656 8.58342 7.33333 8.58342ZM7.33333 6.50008C7.45695 6.50008 7.57778 6.53674 7.68056 6.60541C7.78335 6.67409 7.86345 6.7717 7.91076 6.8859C7.95806 7.00011 7.97044 7.12578 7.94632 7.24701C7.92221 7.36825 7.86268 7.47962 7.77528 7.56702C7.68787 7.65443 7.5765 7.71396 7.45526 7.73807C7.33403 7.76219 7.20836 7.74981 7.09416 7.70251C6.97995 7.6552 6.88234 7.57509 6.81366 7.47231C6.74499 7.36953 6.70833 7.2487 6.70833 7.12508C6.70833 6.95932 6.77418 6.80035 6.89139 6.68314C7.0086 6.56593 7.16757 6.50008 7.33333 6.50008Z"
            fill="white"
          />
          <path
            d="M10.6663 9.83325C10.3779 9.83325 10.096 9.91878 9.85614 10.079C9.61631 10.2393 9.4294 10.467 9.31902 10.7335C9.20864 11 9.17976 11.2932 9.23603 11.5761C9.2923 11.859 9.43119 12.1188 9.63514 12.3228C9.8391 12.5267 10.0989 12.6656 10.3818 12.7219C10.6647 12.7782 10.9579 12.7493 11.2244 12.6389C11.4909 12.5285 11.7187 12.3416 11.8789 12.1018C12.0391 11.862 12.1247 11.58 12.1247 11.2916C12.1247 10.9048 11.971 10.5339 11.6975 10.2604C11.424 9.9869 11.0531 9.83325 10.6663 9.83325ZM10.6663 11.9166C10.5427 11.9166 10.4219 11.8799 10.3191 11.8113C10.2163 11.7426 10.1362 11.645 10.0889 11.5308C10.0416 11.4166 10.0292 11.2909 10.0534 11.1697C10.0775 11.0484 10.137 10.9371 10.2244 10.8496C10.3118 10.7622 10.4232 10.7027 10.5444 10.6786C10.6656 10.6545 10.7913 10.6669 10.9055 10.7142C11.0197 10.7615 11.1173 10.8416 11.186 10.9444C11.2547 11.0471 11.2913 11.168 11.2913 11.2916C11.2913 11.4573 11.2255 11.6163 11.1083 11.7335C10.9911 11.8507 10.8321 11.9166 10.6663 11.9166Z"
            fill="white"
          />
          <path
            d="M12.2253 5.77491C12.1909 5.74039 12.15 5.71301 12.1049 5.69432C12.0599 5.67563 12.0116 5.66602 11.9628 5.66602C11.9141 5.66602 11.8658 5.67563 11.8207 5.69432C11.7757 5.71301 11.7348 5.74039 11.7003 5.77491L5.77533 11.6999C5.70657 11.7701 5.66774 11.8642 5.66699 11.9624C5.66688 12.0358 5.68857 12.1076 5.72931 12.1687C5.77005 12.2298 5.82801 12.2774 5.89584 12.3055C5.96367 12.3337 6.03832 12.341 6.11033 12.3267C6.18234 12.3123 6.24846 12.2769 6.30033 12.2249L12.2253 6.29991C12.2598 6.26547 12.2872 6.22455 12.3059 6.17951C12.3246 6.13446 12.3342 6.08618 12.3342 6.03741C12.3342 5.98865 12.3246 5.94036 12.3059 5.89532C12.2872 5.85027 12.2598 5.80936 12.2253 5.77491Z"
            fill="white"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_262_8413"
            x1="-3.56118"
            y1="-4"
            x2="22.879"
            y2="-3.07303"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF7722" />
            <stop offset="1" stopColor="#FFB800" />
          </linearGradient>
          <clipPath id="clip0_262_8413">
            <rect
              width="10"
              height="10"
              fill="white"
              transform="translate(4 4)"
            />
          </clipPath>
        </defs>
      </>
    );
  },
  meal: (fill = "black") => (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1875 12.1875C12.7975 12.1875 13.3408 12.4808 13.6842 12.935L15.6725 12.395C16.4667 12.175 17.3792 12.6342 17.675 13.4208C17.8149 13.7994 17.8222 14.2142 17.6958 14.5974C17.5694 14.9807 17.3168 15.3097 16.9792 15.5308C13.6383 17.6983 11.1517 18.75 9.375 18.75C8.0375 18.75 6.62167 18.635 5.16667 18.405L4.96167 18.375C4.87632 18.4168 4.78253 18.4385 4.6875 18.4383H2.1875C2.02174 18.4383 1.86277 18.3725 1.74556 18.2553C1.62835 18.1381 1.5625 17.9791 1.5625 17.8133V12.8133C1.5625 12.6476 1.62835 12.4886 1.74556 12.3714C1.86277 12.2542 2.02174 12.1883 2.1875 12.1883L12.1875 12.1875ZM12.1875 13.4375L5.625 13.4417V17.21C6.9225 17.4025 8.18333 17.5 9.375 17.5C10.8808 17.5 13.21 16.485 16.2975 14.4825C16.3966 14.4168 16.4709 14.3198 16.5085 14.207C16.5461 14.0942 16.5449 13.972 16.505 13.86C16.4737 13.7805 16.4194 13.7121 16.349 13.6635C16.2787 13.615 16.1955 13.5885 16.11 13.5875L14.0608 14.13C14.0434 14.6152 13.8383 15.0747 13.489 15.4118C13.1396 15.7489 12.673 15.9374 12.1875 15.9375H8.4375C8.27174 15.9375 8.11277 15.8717 7.99556 15.7544C7.87835 15.6372 7.8125 15.4783 7.8125 15.3125C7.8125 15.1467 7.87835 14.9878 7.99556 14.8706C8.11277 14.7533 8.27174 14.6875 8.4375 14.6875H12.1833C12.2657 14.6878 12.3473 14.6719 12.4235 14.6407C12.4997 14.6094 12.569 14.5635 12.6275 14.5054C12.6859 14.4474 12.7323 14.3784 12.7641 14.3024C12.7958 14.2264 12.8123 14.1449 12.8125 14.0625C12.8121 13.8969 12.7461 13.7382 12.629 13.621C12.5118 13.5039 12.3531 13.4379 12.1875 13.4375ZM4.37333 13.4375H2.8125V17.1875H4.37333V13.4375Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0002 1.25C10.1732 1.24997 10.3443 1.28585 10.5028 1.35539C10.6612 1.42492 10.8035 1.52659 10.9206 1.65396C11.0377 1.78133 11.1271 1.93162 11.1831 2.09533C11.2391 2.25904 11.2605 2.43259 11.246 2.605C12.9469 2.89129 14.4971 3.75516 15.6354 5.05103C16.7737 6.3469 17.4305 7.99555 17.4952 9.71917L17.5002 10H18.1252C18.2814 9.99971 18.432 10.0579 18.5474 10.1631C18.6628 10.2684 18.7347 10.413 18.7488 10.5685C18.7629 10.7241 18.7182 10.8793 18.6237 11.0035C18.5291 11.1278 18.3914 11.2122 18.2377 11.24L18.1252 11.25H1.87518C1.71899 11.2503 1.56836 11.1921 1.45295 11.0869C1.33753 10.9816 1.26569 10.837 1.25158 10.6815C1.23747 10.5259 1.28211 10.3707 1.3767 10.2465C1.47129 10.1222 1.60899 10.0378 1.76268 10.01L1.87518 10H2.50018C2.50018 6.28167 5.20601 3.19583 8.75517 2.6025L8.75017 2.5C8.75017 2.16848 8.88187 1.85054 9.11629 1.61612C9.35071 1.3817 9.66865 1.25 10.0002 1.25ZM10.0002 3.75C8.38945 3.74999 6.84092 4.37183 5.67755 5.48583C4.51418 6.59983 3.82581 8.11996 3.75601 9.72917L3.74934 10H16.2502C16.2502 8.38928 15.6283 6.84074 14.5143 5.67737C13.4003 4.514 11.8802 3.82563 10.271 3.75583L10.0002 3.75Z"
        fill={fill}
      />
    </>
  ),
  creditCard: (fill = "black") => (
    <>
      <g clipPath="url(#clip0_262_8430)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.75 10V13.75C18.7493 14.2249 18.5687 14.6819 18.2446 15.029C17.9206 15.3761 17.477 15.5875 17.0033 15.6208L16.875 15.625H3.125C2.65012 15.6243 2.19315 15.4437 1.84604 15.1196C1.49893 14.7956 1.28745 14.352 1.25417 13.8783L1.25 13.75V10H18.75ZM11.875 11.875H10C9.83424 11.875 9.67527 11.9408 9.55806 12.0581C9.44085 12.1753 9.375 12.3342 9.375 12.5C9.375 12.6658 9.44085 12.8247 9.55806 12.9419C9.67527 13.0592 9.83424 13.125 10 13.125H11.875C12.0408 13.125 12.1997 13.0592 12.3169 12.9419C12.4342 12.8247 12.5 12.6658 12.5 12.5C12.5 12.3342 12.4342 12.1753 12.3169 12.0581C12.1997 11.9408 12.0408 11.875 11.875 11.875ZM6.875 11.875H5C4.83424 11.875 4.67527 11.9408 4.55806 12.0581C4.44085 12.1753 4.375 12.3342 4.375 12.5C4.375 12.6658 4.44085 12.8247 4.55806 12.9419C4.67527 13.0592 4.83424 13.125 5 13.125H6.875C7.04076 13.125 7.19973 13.0592 7.31694 12.9419C7.43415 12.8247 7.5 12.6658 7.5 12.5C7.5 12.3342 7.43415 12.1753 7.31694 12.0581C7.19973 11.9408 7.04076 11.875 6.875 11.875ZM16.875 4.375C17.9083 4.375 18.75 5.21667 18.75 6.25V7.5H1.25V6.25C1.25 5.21667 2.09167 4.375 3.125 4.375H16.875Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_262_8430">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </>
  ),
  direction: (fill = "#22AAFF") => (
    <>
      <g clipPath="url(#clip0_262_8317)">
        <path
          d="M18.0916 9.4083L10.5916 1.9083C10.2666 1.5833 9.7416 1.5833 9.4166 1.9083L1.9166 9.4083C1.5916 9.7333 1.5916 10.2583 1.9166 10.5833L9.4166 18.0833C9.7416 18.4083 10.2666 18.4083 10.5916 18.0833L18.0916 10.5833C18.4166 10.2666 18.4166 9.74163 18.0916 9.4083ZM11.6666 12.0833V9.99997H8.33327V12.5H6.6666V9.16663C6.6666 8.7083 7.0416 8.3333 7.49993 8.3333H11.6666V6.24997L14.5833 9.16663L11.6666 12.0833Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_262_8317">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </>
  ),
  clock: () => (
    <>
      <path
        d="M9.16634 7.49732V4.16398C9.16634 3.98717 9.0961 3.8176 8.97108 3.69258C8.84606 3.56755 8.67649 3.49731 8.49968 3.49731C8.32286 3.49731 8.1533 3.56755 8.02827 3.69258C7.90325 3.8176 7.83301 3.98717 7.83301 4.16398V8.16398C7.83301 8.34079 7.90325 8.51036 8.02827 8.63539C8.1533 8.76041 8.32286 8.83065 8.49968 8.83065H11.833C12.0098 8.83065 12.1794 8.76041 12.3044 8.63539C12.4294 8.51036 12.4997 8.34079 12.4997 8.16398C12.4997 7.98717 12.4294 7.8176 12.3044 7.69258C12.1794 7.56755 12.0098 7.49732 11.833 7.49732H9.16634ZM8.49968 14.8306C4.81767 14.8306 1.83301 11.846 1.83301 8.16398C1.83301 4.48198 4.81767 1.49731 8.49968 1.49731C12.1817 1.49731 15.1663 4.48198 15.1663 8.16398C15.1663 11.846 12.1817 14.8306 8.49968 14.8306Z"
        fill="url(#paint0_linear_262_8358)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_262_8358"
          x1="2.11954"
          y1="2.30191"
          x2="15.4892"
          y2="2.6565"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7722" />
          <stop offset="1" stopColor="#FFB800" />
        </linearGradient>
      </defs>
    </>
  ),
  phone: () => (
    <>
      <path
        d="M16.461 12.1651C16.4351 12.2779 16.3919 12.3858 16.333 12.4852C15.8799 13.226 15.3263 13.9007 14.6883 14.4899C14.4977 14.6426 14.2972 14.7827 14.0883 14.9091L13.6083 14.9395C13.3763 14.9091 13.1395 14.8819 12.9124 14.8403C11.8857 14.6297 10.9007 14.2513 9.99707 13.7203C8.44679 12.8564 7.05975 11.7716 5.73009 10.6022C4.51217 9.55578 3.39827 8.39423 2.40393 7.13345C1.7207 6.24385 1.11916 5.30952 0.754342 4.23756C0.664725 3.97362 0.603902 3.69998 0.530356 3.43759L0.5 2.94967C0.703229 2.34332 1.1128 1.87617 1.54316 1.42653C1.86312 1.09697 2.19268 0.786608 2.52872 0.477791C2.81007 0.217644 3.20024 0.110291 3.57511 0.189745C3.78927 0.221775 3.98235 0.336725 4.11269 0.509818C4.8006 1.42184 5.48061 2.34009 6.19264 3.22968H6.19252C6.33917 3.4049 6.43348 3.61795 6.46461 3.84429C6.49575 4.07073 6.46249 4.3013 6.36852 4.50966C6.28214 4.73845 6.16853 4.95765 6.0645 5.18007C5.94286 5.43764 5.82132 5.6969 5.68852 5.94969L5.68863 5.94958C5.63026 6.02714 5.64287 6.13685 5.71742 6.19913C6.19743 6.69028 6.65499 7.20389 7.15731 7.67587V7.67598C8.08162 8.57594 9.08158 9.395 10.1461 10.1239C10.2402 10.2067 10.3814 10.2067 10.4756 10.1239C10.8644 9.85994 11.2596 9.60393 11.6596 9.35426C11.9384 9.15739 12.2811 9.07279 12.6195 9.11744C12.7228 9.13418 12.8225 9.16888 12.9139 9.21988C13.972 9.82255 15.028 10.4283 16.0818 11.0374C16.4211 11.2294 16.5794 11.7094 16.461 12.1653L16.461 12.1651Z"
        fill="url(#paint0_linear_262_8366)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_262_8366"
          x1="0.84384"
          y1="1.05568"
          x2="16.8855"
          y2="1.5164"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7722" />
          <stop offset="1" stopColor="#FFB800" />
        </linearGradient>
      </defs>
    </>
  ),
  envelop: () => (
    <>
      <path
        d="M16.415 0.761442L8.72357 6.01601H8.72134C8.71029 6.02349 8.69879 6.0303 8.68696 6.03666L8.67792 6.04135C8.66542 6.04771 8.65259 6.05351 8.63953 6.05854C8.6258 6.06367 8.61185 6.06802 8.59768 6.07159H8.59422C8.58004 6.07505 8.56576 6.07762 8.55136 6.07941C8.54946 6.07941 8.54756 6.08755 8.54578 6.08789C8.53082 6.09336 8.51553 6.09793 8.50013 6.10162C8.48585 6.09894 8.47156 6.09548 8.45761 6.09135C8.45571 6.09135 8.45381 6.087 8.45225 6.087L8.45236 6.08688C8.43808 6.08443 8.42401 6.08119 8.41017 6.07729C8.41017 6.07729 8.40772 6.07572 8.40616 6.07539H8.40604C8.39187 6.07171 8.37792 6.06724 8.36419 6.06188C8.35125 6.05697 8.33863 6.05139 8.32636 6.04503L8.31732 6.04034C8.30638 6.03443 8.29511 6.02818 8.28607 6.02093H8.28417L8.28171 6.01936L0.5 0.835362V10.7728C0.500112 10.8928 0.547769 11.0077 0.632254 11.0928C0.716851 11.1777 0.831697 11.2258 0.951569 11.2266H16.0484C16.1685 11.2258 16.2834 11.1776 16.368 11.0924C16.4527 11.0072 16.5001 10.892 16.5 10.7719V0.681885C16.4757 0.712465 16.447 0.739139 16.4147 0.761236L16.415 0.761442Z"
        fill="url(#paint0_linear_262_8367)"
      />
      <path
        d="M8.49772 5.22263L15.8997 0.164062H0.952289C0.937333 0.164062 0.9226 0.166518 0.908203 0.167857C0.914453 0.171651 0.920703 0.175 0.926953 0.179129L8.49772 5.22263Z"
        fill="url(#paint1_linear_262_8367)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_262_8367"
          x1="0.84384"
          y1="1.3182"
          x2="16.8728"
          y2="1.96326"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7722" />
          <stop offset="1" stopColor="#FFB800" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_262_8367"
          x1="1.23037"
          y1="0.469321"
          x2="16.181"
          y2="1.64445"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7722" />
          <stop offset="1" stopColor="#FFB800" />
        </linearGradient>
      </defs>
    </>
  ),
  web: () => (
    <>
      <path
        d="M16.1151 5.71291C15.5969 4.1013 14.5804 2.69569 13.2123 1.69854C11.8442 0.701396 10.195 0.164062 8.50187 0.164062C6.80878 0.164062 5.15964 0.701396 3.79143 1.69854C2.42331 2.69557 1.40686 4.10117 0.888603 5.71291L0.884865 5.72189C0.371712 7.31105 0.371712 9.02136 0.884865 10.6107L0.888603 10.6196V10.6195C1.40686 12.2311 2.42331 13.6367 3.79143 14.6339C5.15955 15.6309 6.80878 16.1682 8.50187 16.1682C10.195 16.1682 11.8441 15.6309 13.2123 14.6339C14.5804 13.6367 15.5969 12.2311 16.1151 10.6195V10.6105V10.6107C16.6283 9.02136 16.6283 7.31085 16.1151 5.72189V5.71291ZM8.50206 15.0544C7.65197 15.0544 6.72759 13.4168 6.31001 10.9606H10.6941C10.2764 13.4206 9.35205 15.0544 8.50193 15.0544H8.50206ZM6.1656 9.84404C6.11426 9.31034 6.08298 8.75282 6.08298 8.16926C6.08298 7.5857 6.11426 7.02818 6.1656 6.49448H10.8387C10.8901 7.02818 10.9213 7.5857 10.9213 8.16926C10.9213 8.75282 10.8901 9.31034 10.8387 9.84404H6.1656ZM1.61689 8.16926C1.61914 7.60427 1.69116 7.04176 1.83123 6.49448H5.04521C4.99537 7.04974 4.96633 7.611 4.96633 8.16926C4.96633 8.72752 4.99536 9.28578 5.04521 9.84404H1.83123C1.69116 9.29675 1.61914 8.73425 1.61689 8.16926ZM8.502 1.28416C9.35208 1.28416 10.2765 2.92168 10.694 5.37796H6.30995C6.72753 2.91788 7.65188 1.28416 8.502 1.28416ZM11.9587 6.49448H15.1727C15.4586 7.59269 15.4586 8.74583 15.1727 9.84404H11.9587C12.0086 9.28878 12.0376 8.72752 12.0376 8.16926C12.0376 7.611 12.0086 7.05274 11.9587 6.49448ZM14.7873 5.37796H11.8218C11.6533 4.05408 11.234 2.77458 10.5862 1.60795C11.5128 1.90515 12.3662 2.39462 13.0906 3.04421C13.8151 3.69393 14.3943 4.48921 14.7903 5.37805L14.7873 5.37796ZM6.41787 1.60795C5.77 2.77468 5.3507 4.05421 5.18223 5.37796H2.21372C2.60974 4.48911 3.18892 3.69383 3.91342 3.04411C4.63778 2.39452 5.49125 1.90504 6.41787 1.60785V1.60795ZM2.21369 10.9606H5.1822C5.35067 12.2844 5.77 13.5639 6.41784 14.7306C5.49122 14.4334 4.63775 13.9439 3.91338 13.2943C3.18889 12.6446 2.6097 11.8493 2.21369 10.9605V10.9606ZM10.586 14.7306C11.2339 13.5638 11.6532 12.2843 11.8216 10.9606H14.7901C14.3941 11.8494 13.8149 12.6447 13.0904 13.2944C12.3661 13.944 11.5126 14.4335 10.586 14.7307V14.7306Z"
        fill="url(#paint0_linear_262_8370)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_262_8370"
          x1="0.84384"
          y1="1.12983"
          x2="16.8875"
          y2="1.55523"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7722" />
          <stop offset="1" stopColor="#FFB800" />
        </linearGradient>
      </defs>
    </>
  ),
  instagram: () => (
    <>
      <path
        d="M5.18673 0.220013C4.33553 0.260173 3.75425 0.396013 3.24609 0.595693C2.72017 0.800653 2.27441 1.07569 1.83089 1.52081C1.38737 1.96593 1.11425 2.41201 0.910733 2.93873C0.713773 3.44801 0.580333 4.02977 0.542733 4.88145C0.505133 5.73313 0.496813 6.00689 0.500973 8.17937C0.505133 10.3519 0.514733 10.6242 0.556013 11.4776C0.596653 12.3287 0.732013 12.9098 0.931693 13.4181C1.13697 13.944 1.41169 14.3896 1.85697 14.8333C2.30225 15.277 2.74801 15.5495 3.27601 15.7533C3.78481 15.9499 4.36673 16.084 5.21825 16.1213C6.06977 16.1586 6.34385 16.1672 8.51569 16.1631C10.6875 16.1589 10.961 16.1493 11.8143 16.1088C12.6675 16.0683 13.2456 15.932 13.7541 15.7333C14.28 15.5275 14.7259 15.2533 15.1693 14.8079C15.6127 14.3624 15.8856 13.916 16.089 13.389C16.2861 12.8802 16.42 12.2983 16.457 11.4474C16.4943 10.5935 16.5031 10.3208 16.4989 8.14865C16.4947 5.97649 16.485 5.70417 16.4445 4.85105C16.404 3.99793 16.2685 3.41857 16.069 2.90993C15.8634 2.38401 15.589 1.93873 15.1439 1.49473C14.6987 1.05073 14.252 0.777933 13.7251 0.575053C13.216 0.378093 12.6344 0.243853 11.7829 0.207053C10.9314 0.170253 10.6573 0.160813 8.48465 0.164973C6.31201 0.169133 6.04001 0.178413 5.18673 0.220013ZM5.28017 14.6821C4.50017 14.6482 4.07665 14.5186 3.79441 14.4101C3.42065 14.2661 3.15441 14.092 2.87313 13.8135C2.59185 13.5349 2.41905 13.2677 2.27313 12.8947C2.16353 12.6125 2.03153 12.1895 1.99505 11.4095C1.95537 10.5664 1.94705 10.3133 1.94241 8.17745C1.93777 6.04161 1.94593 5.78881 1.98289 4.94545C2.01617 4.16609 2.14657 3.74209 2.25489 3.46001C2.39889 3.08577 2.57233 2.82001 2.85153 2.53889C3.13073 2.25777 3.39713 2.08465 3.77041 1.93873C4.05233 1.82865 4.47537 1.69777 5.25505 1.66065C6.09873 1.62065 6.35153 1.61265 8.48705 1.60801C10.6226 1.60337 10.876 1.61137 11.72 1.64849C12.4994 1.68241 12.9235 1.81153 13.2053 1.92049C13.5792 2.06449 13.8453 2.23745 14.1264 2.51713C14.4075 2.79681 14.5808 3.06225 14.7267 3.43633C14.837 3.71745 14.9679 4.14033 15.0047 4.92049C15.0448 5.76417 15.0539 6.01713 15.0578 8.15249C15.0616 10.2879 15.0541 10.5415 15.0171 11.3845C14.9831 12.1645 14.8538 12.5882 14.7451 12.8707C14.6011 13.2443 14.4275 13.5107 14.1482 13.7917C13.8688 14.0727 13.6027 14.2458 13.2293 14.3917C12.9477 14.5016 12.5242 14.6328 11.7451 14.6699C10.9015 14.7096 10.6487 14.7179 8.51233 14.7226C6.37601 14.7272 6.12401 14.7186 5.28033 14.6821M11.8019 3.88833C11.8022 4.07822 11.8589 4.26374 11.9646 4.42144C12.0704 4.57914 12.2206 4.70194 12.3961 4.7743C12.5717 4.84665 12.7647 4.86533 12.9509 4.82795C13.1371 4.79057 13.308 4.69882 13.442 4.56431C13.576 4.42979 13.6671 4.25856 13.7038 4.07225C13.7405 3.88595 13.7212 3.69295 13.6481 3.51766C13.5751 3.34237 13.4518 3.19266 13.2937 3.08748C13.1356 2.98229 12.9499 2.92635 12.76 2.92673C12.5055 2.92724 12.2615 3.02883 12.0819 3.20915C11.9022 3.38948 11.8015 3.63378 11.8019 3.88833ZM4.39233 8.17201C4.39681 10.4408 6.23937 12.2759 8.50769 12.2715C10.776 12.2672 12.6123 10.4248 12.608 8.15601C12.6037 5.88721 10.7607 4.05169 8.49201 4.05617C6.22337 4.06065 4.38801 5.90353 4.39233 8.17201ZM5.83329 8.16913C5.83225 7.64171 5.98763 7.12582 6.27978 6.6867C6.57194 6.24758 6.98775 5.90496 7.47462 5.70215C7.9615 5.49935 8.49758 5.44548 9.01508 5.54735C9.53257 5.64923 10.0082 5.90226 10.3819 6.27447C10.7556 6.64668 11.0105 7.12134 11.1145 7.63843C11.2184 8.15552 11.1666 8.69181 10.9658 9.17949C10.7649 9.66716 10.4239 10.0843 9.98595 10.3782C9.54799 10.6721 9.03272 10.8295 8.50529 10.8306C8.15508 10.8313 7.80816 10.763 7.48433 10.6297C7.16051 10.4963 6.86612 10.3005 6.618 10.0533C6.36987 9.80619 6.17286 9.51259 6.03822 9.18929C5.90358 8.866 5.83394 8.51934 5.83329 8.16913Z"
        fill="url(#paint0_linear_262_8384)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_262_8384"
          x1="0.843836"
          y1="1.12958"
          x2="16.8873"
          y2="1.55508"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7722" />
          <stop offset="1" stopColor="#FFB800" />
        </linearGradient>
      </defs>
    </>
  ),
  cutlery: () => (
    <>
      <path
        d="M4.97656 5.75852H6.24557L6.09484 14.2111H7.58808V0.164062H6.34489L4.97656 5.75852Z"
        fill="url(#paint0_linear_262_8371)"
      />
      <path
        d="M3.23652 0.164062V4.01696H2.67747V0.164062H1.93087V4.01696H1.37182V0.164062H0.625078L0.5 5.75852H1.77643L1.55757 14.2111H3.04901V5.75852H4.10646L3.98138 0.164062H3.23652Z"
        fill="url(#paint1_linear_262_8371)"
      />
      <path
        d="M16.4996 4.34603V0.164062H9.49463V4.34603C9.49463 6.60319 10.4675 7.78874 12.4132 7.9027V13.1533H9.43945V14.2108H16.4444V13.1533H13.465V7.90632C15.4819 7.82909 16.4915 6.6422 16.4939 4.34603H16.4996Z"
        fill="url(#paint2_linear_262_8371)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_262_8371"
          x1="5.03268"
          y1="1.01173"
          x2="7.6531"
          y2="1.02465"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7722" />
          <stop offset="1" stopColor="#FFB800" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_262_8371"
          x1="0.577503"
          y1="1.01173"
          x2="4.19617"
          y2="1.03637"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7722" />
          <stop offset="1" stopColor="#FFB800" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_262_8371"
          x1="9.59118"
          y1="1.01171"
          x2="16.6743"
          y2="1.10613"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7722" />
          <stop offset="1" stopColor="#FFB800" />
        </linearGradient>
      </defs>
    </>
  ),
  wallet: () => (
    <>
      <path
        d="M11.5824 0.19051L0.5 2.95224H12.7351V1.18078C12.7351 0.52733 12.1721 0.0435969 11.5824 0.19051H11.5824Z"
        fill="url(#paint0_linear_262_8376)"
      />
      <path
        d="M16.4996 4.98476C16.4996 4.42347 16.0783 3.96851 15.5585 3.96851H0.5V9.55807H8.97057V8.03356C8.97057 7.47228 9.3919 7.01731 9.91167 7.01731H16.5L16.4996 4.98476Z"
        fill="url(#paint1_linear_262_8376)"
      />
      <path
        d="M8.97053 12.0989C8.97053 12.6602 9.39187 13.1152 9.91163 13.1152H16.4999V15.1478C16.4999 15.7091 16.0786 16.1641 15.5588 16.1641H1.4411C0.921334 16.1641 0.5 15.7091 0.5 15.1478V10.5745H8.97057L8.97053 12.0989Z"
        fill="url(#paint2_linear_262_8376)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.91211 12.0989H16.5004V8.03369H9.91211V12.0989ZM11.7945 9.05005C11.2747 9.05005 10.8533 9.50512 10.8533 10.0663C10.8533 10.6276 11.2747 11.0826 11.7945 11.0826C12.3142 11.0826 12.7356 10.6276 12.7356 10.0663C12.7356 9.50515 12.3142 9.05005 11.7945 9.05005Z"
        fill="url(#paint3_linear_262_8376)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_262_8376"
          x1="0.762932"
          y1="0.332314"
          x2="12.876"
          y2="1.74209"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7722" />
          <stop offset="1" stopColor="#FFB800" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_262_8376"
          x1="0.843839"
          y1="4.30581"
          x2="16.8067"
          y2="5.51769"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7722" />
          <stop offset="1" stopColor="#FFB800" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_262_8376"
          x1="0.843838"
          y1="10.9118"
          x2="16.8067"
          y2="12.1236"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7722" />
          <stop offset="1" stopColor="#FFB800" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_262_8376"
          x1="10.0537"
          y1="8.27901"
          x2="16.6524"
          y2="8.56264"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7722" />
          <stop offset="1" stopColor="#FFB800" />
        </linearGradient>
      </defs>
    </>
  ),
  parking: () => (
    <>
      <path
        d="M9.04161 5.27051H7.47852V7.82369H9.01608C9.4466 7.82369 9.77441 7.74486 9.99976 7.52936C10.2256 7.31458 10.3385 7.02523 10.3385 6.63307C10.3385 6.20255 10.222 5.88958 9.9904 5.63216C9.75851 5.37499 9.44222 5.27052 9.04161 5.27052V5.27051Z"
        fill="url(#paint0_linear_262_8381)"
      />
      <path
        d="M14.2868 0.164062H2.7579C1.53368 0.164062 0.5 1.19345 0.5 2.41804V13.9469C0.5 15.1712 1.53368 16.1639 2.7579 16.1639H14.2868C15.5112 16.1639 16.5 15.1712 16.5 13.947V2.41813C16.5 1.19354 15.5112 0.164154 14.2866 0.164154L14.2868 0.164062ZM11.6264 8.75371C10.983 9.29167 10.1001 9.52569 8.97843 9.52569H7.47886V12.7597H5.26607V3.56825H9.01652C9.72071 3.56825 10.3445 3.66834 10.8859 3.92789C11.4282 4.18707 11.8477 4.5415 12.1452 5.0201C12.4419 5.49895 12.5908 6.01685 12.5908 6.62438C12.5909 7.52283 12.2695 8.21645 11.6265 8.75371H11.6264Z"
        fill="url(#paint1_linear_262_8381)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_262_8381"
          x1="7.53998"
          y1="5.42458"
          x2="10.4073"
          y2="5.50976"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7722" />
          <stop offset="1" stopColor="#FFB800" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_262_8381"
          x1="0.84384"
          y1="1.12957"
          x2="16.8875"
          y2="1.55509"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7722" />
          <stop offset="1" stopColor="#FFB800" />
        </linearGradient>
      </defs>
    </>
  ),
  arrowLeft: () => (
    <>
      <g clipPath="url(#clip0_262_12886)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.1244 17.0832C12.9244 17.0832 12.7244 17.0115 12.5635 16.8665L5.68936 10.6199C5.60357 10.5418 5.53502 10.4466 5.48812 10.3405C5.44122 10.2344 5.41699 10.1196 5.41699 10.0036C5.41699 9.88761 5.44122 9.77287 5.48812 9.66675C5.53502 9.56063 5.60357 9.46548 5.68936 9.38738L12.5635 3.13404C12.7281 2.99323 12.941 2.922 13.1571 2.93545C13.3733 2.94889 13.5757 3.04595 13.7215 3.20607C13.8673 3.36619 13.9451 3.57679 13.9383 3.79325C13.9315 4.00971 13.8407 4.21503 13.6852 4.36571L7.48853 10.0032L13.6852 15.6332C13.8088 15.7467 13.8954 15.8949 13.9335 16.0583C13.9717 16.2218 13.9597 16.3929 13.8992 16.5494C13.8386 16.706 13.7323 16.8406 13.5941 16.9358C13.4559 17.0311 13.2922 17.0824 13.1244 17.0832Z"
          fill="url(#paint0_linear_262_12886)"
        />
      </g>

      <defs>
        <linearGradient
          id="paint0_linear_262_12886"
          x1="5.5611"
          y1="2.93384"
          x2="14.2509"
          y2="3.11768"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7722" />
          <stop offset="1" stopColor="#FFB800" />
        </linearGradient>
        <clipPath id="clip0_262_12886">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </>
  ),
  arrowRight: () => (
    <>
      <g clipPath="url(#clip0_262_12890)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.87478 17.0834C6.70695 17.0826 6.54325 17.0312 6.40504 16.936C6.26682 16.8408 6.16051 16.7061 6.09996 16.5496C6.03942 16.3931 6.02745 16.2219 6.06562 16.0585C6.10379 15.895 6.19033 15.7469 6.31395 15.6334L12.5106 10.0034L6.31395 4.36587C6.22917 4.29331 6.15982 4.20446 6.11002 4.10459C6.06023 4.00472 6.031 3.89586 6.02407 3.78448C6.01714 3.6731 6.03265 3.56146 6.06969 3.45619C6.10672 3.35092 6.16453 3.25416 6.23967 3.17165C6.31481 3.08914 6.40576 3.02256 6.50711 2.97587C6.60847 2.92917 6.71818 2.90331 6.82972 2.89982C6.94126 2.89633 7.05237 2.91528 7.15645 2.95554C7.26053 2.9958 7.35546 3.05656 7.43562 3.13421L14.3098 9.38754C14.3956 9.46564 14.4641 9.5608 14.511 9.66691C14.5579 9.77303 14.5822 9.88777 14.5822 10.0038C14.5822 10.1198 14.5579 10.2346 14.511 10.3407C14.4641 10.4468 14.3956 10.5419 14.3098 10.62L7.43562 16.8667C7.27478 17.0117 7.07478 17.0834 6.87478 17.0834Z"
          fill="url(#paint0_linear_262_12890)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_262_12890"
          x1="6.16693"
          y1="2.89942"
          x2="14.8784"
          y2="3.08373"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7722" />
          <stop offset="1" stopColor="#FFB800" />
        </linearGradient>
        <clipPath id="clip0_262_12890">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </>
  ),
  share: () => (
    <>
      <path
        d="M30 14.3279C32.7614 14.3279 35 12.0893 35 9.32788C35 6.56646 32.7614 4.32788 30 4.32788C27.2386 4.32788 25 6.56646 25 9.32788C25 12.0893 27.2386 14.3279 30 14.3279Z"
        stroke="#8F90A6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 25.9946C12.7614 25.9946 15 23.7561 15 20.9946C15 18.2332 12.7614 15.9946 10 15.9946C7.23858 15.9946 5 18.2332 5 20.9946C5 23.7561 7.23858 25.9946 10 25.9946Z"
        stroke="#8F90A6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30 37.6614C32.7614 37.6614 35 35.4228 35 32.6614C35 29.9 32.7614 27.6614 30 27.6614C27.2386 27.6614 25 29.9 25 32.6614C25 35.4228 27.2386 37.6614 30 37.6614Z"
        stroke="#8F90A6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3164 23.5112L25.6997 30.1446"
        stroke="#8F90A6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.6831 11.8447L14.3164 18.4781"
        stroke="#8F90A6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  heart: () => (
    <>
      <svg
        width="40"
        height="41"
        viewBox="0 0 40 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M31.7598 6.68988C32.8722 7.15082 33.8829 7.82642 34.7342 8.67808C35.5858 9.52934 36.2614 10.5401 36.7224 11.6525C37.1833 12.7649 37.4206 13.9573 37.4206 15.1614C37.4206 16.3656 37.1833 17.5579 36.7224 18.6703C36.2614 19.7828 35.5858 20.7935 34.7342 21.6447L32.9675 23.4114L20.0009 36.3781L7.03418 23.4114L5.26752 21.6447C3.54803 19.9253 2.58203 17.5931 2.58203 15.1614C2.58203 12.7297 3.54803 10.3976 5.26752 8.67808C6.987 6.95859 9.31913 5.99259 11.7508 5.99259C14.1826 5.99259 16.5147 6.95859 18.2342 8.67808L20.0009 10.4447L21.7675 8.67808C22.6188 7.82642 23.6295 7.15082 24.7419 6.68988C25.8544 6.22894 27.0467 5.9917 28.2509 5.9917C29.455 5.9917 30.6473 6.22894 31.7598 6.68988Z"
          stroke="#8F90A6"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  ),
  facebook_2: () => (
    <>
      <path
        d="M16 8.00002C16 3.58174 12.4183 1.80736e-05 8 1.80736e-05C3.58172 1.80736e-05 0 3.58174 0 8.00002C0 11.993 2.92548 15.3027 6.75 15.9028V10.3125H4.71875V8.00002H6.75V6.23752C6.75 4.23252 7.94434 3.12502 9.77172 3.12502C10.647 3.12502 11.5625 3.28127 11.5625 3.28127V5.25002H10.5537C9.55992 5.25002 9.25 5.86669 9.25 6.49935V8.00002H11.4688L11.1141 10.3125H9.25V15.9028C13.0745 15.3027 16 11.993 16 8.00002Z"
        fill="url(#paint0_linear_1414_164)"
      />
      <path
        d="M11.1141 10.3125L11.4688 8H9.25V6.49933C9.25 5.86667 9.55992 5.25 10.5537 5.25H11.5625V3.28125C11.5625 3.28125 10.647 3.125 9.77172 3.125C7.94434 3.125 6.75 4.2325 6.75 6.2375V8H4.71875V10.3125H6.75V15.9028C7.1573 15.9667 7.57475 16 8 16C8.42525 16 8.8427 15.9667 9.25 15.9028V10.3125H11.1141Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1414_164"
          x1="0.270042"
          y1="15.9028"
          x2="16.5407"
          y2="15.3289"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7722" />
          <stop offset="1" stopColor="#FFB800" />
        </linearGradient>
        <clipPath id="clip0_1414_164">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </>
  ),
};
export default function Icon({
  name,
  width = 24,
  height = 24,
  fill,
}: iconProps) {
  return (
    <>
      {fill ? (
        <svg
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {Icons[name](fill)}
        </svg>
      ) : (
        <svg
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {Icons[name]()}
        </svg>
      )}
    </>
  );
}
